import { Component, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { LocLabel } from '../../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss']
})
export class TimeInputComponent implements ControlValueAccessor {
  @Input() labelKey: string | LocLabel | null | undefined;
  @Input() disabled = false;
  @Input() placeholderKey: string | LocLabel | null | undefined;
  @Input() outsideLabel = true;
  @Input() required = false;
  @Input() footer = true;

  @Input() showSeconds = false;

  private _value: any;

  constructor(public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  // this method sets the value programmatically
  // tslint:disable-next-line:typedef
  public writeValue(value: string) {
    if (value !== this._value) {
      this._value = value;
    }
  }

  get value(): string {
    return this._value;
  }

  set value(value: string) {
    this.writeValue(value);
    this.onChange(value);
    this.onTouch(value);
  }

  // upon UI element value changes, this method gets triggered
  // tslint:disable-next-line:typedef
  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // upon touching the element, this method gets triggered
  // tslint:disable-next-line:typedef
  public registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  public onChange: any = (value: any) => {
    this.value = value;
  };

  public onTouch: any = () => {};

  public get control(): FormControl {
    const ctrl = this.ngControl.control;
    if (!ctrl) throw new Error('Invalid control for time-input');
    return ctrl as FormControl;
  }
}
